import Option from "./Option";
// List of options
export default function OptionList({
  options,
  question,
  updateOption,
  removeOption,
  isSelected,
  selectedId,
  handleAddOptionAfterIndex,
  disabled,
  disabledOptionIds,
  allowOptionAdd
}) {
  const handleChange = (id, key) => (event) => {
    const el = options.find((option) => option.id === id);
    const newOption = {
      ...el,
      [key]: key === "number" ? Number(event.target.value) : event.target.value,
    };
    updateOption(id, newOption);
  };

  return options.map((option, index) => (
    <Option
      key={"Option" + option.id}
      option={option}
      index={index}
      type={question.type}
      isSelected={isSelected}
      selectedId={selectedId}
      handleChange={handleChange}
      removeOption={removeOption}
      handleAddOptionAfterIndex={handleAddOptionAfterIndex}
      disabled={disabled || disabledOptionIds.includes(option.id)}
      allowOptionAdd={allowOptionAdd}
    />
  ));
}
